module.exports = __webpack_public_path__ + "media/images/badges/cyclebar/grey/RideClub_Milestones_App_1250-Grey-be12200639a529f62844d87b870b6df0.png";